import React, { useState } from "react";
import "../../../assests/css/students/Contact.css";
import TopHero from "../../../subscreens/TopHero/TopHero";
import ContactForm from "../../../subscreens/contact/ContactForm";

export default function Contact() {
  // const [formData, setFormData] = useState({
  //   name: "",
  //   email: "",
  //   phone: "",
  //   subject: "",
  //   message: "",
  // });

  // const handleChange = (e) => {
  //   setFormData({ ...formData, [e.target.name]: e.target.value });
  // };

  // const handleSubmit = (e) => {
  //   e.preventDefault();
  //   if (
  //     !formData.name ||
  //     !formData.email ||
  //     !formData.subject ||
  //     !formData.message
  //   ) {
  //     alert("Please fill all required fields");
  //     return;
  //   }
  //   alert("Message sent successfully!");
  //   setFormData({
  //     name: "",
  //     email: "",
  //     phone: "",
  //     subject: "",
  //     message: "",
  //   });
  // };

  return (
    <div className="contact-page">
      {/* ================= HERO ================= */}
      <TopHero
        title="Contact Us"
        description="For any information regarding the University, its programs, admissions and general queries, please contact us."
      />

      {/* <section className="contact-hero">
        <div className="hero-bg"></div>
        <div className="hero-overlay"></div> */}

      {/* HERO CONTENT (Moved from Contact Info Section) */}
      {/* <div className="hero-content">
          <h2>Contact Us</h2>
          <p>
            For any information regarding the University, its programs,
            admissions and any general queries please contact the relevant
            department or person below. In the case of important queries or
            comments the Rector or Chairman of the University can also be
            contacted directly.
          </p>
        </div>
      </section> */}

      {/* ================= CONTACT INFO SECTION ================= */}
      <section className="contact-info-section">
        <div className="contact-info-container">
          <div className="info-grid">
            <div className="info-card">
              <h3>GGCW Campus 📍</h3>
              <p>Government Graduate College For Women Satellite Town</p>
              <p>Gujranwala- 52250.</p>
            </div>

            <div className="info-card">
              <h3>Email</h3>
              <p>
                <a href="mailto:info@gift.edu.pk">info@ggcw.edu.pk</a>
              </p>
            </div>

            <div className="info-card">
              <h3>Contact</h3>
              <p>UAN: +92 (55) 111 900 100</p>
              <p>Toll Free: 0800 04438</p>
              <p>Phone: +92 (55) 3466900-3</p>
            </div>
          </div>
        </div>
      </section>

      {/* ================= CONTACT FORM ================= */}

      <section className="contact-wrapper">
        <ContactForm />
        {/* <div className="contact-box">
          <div className="contact-form">
            <h1>Get In Touch</h1>
           <p>We'd love to hear from you</p>

            <form onSubmit={handleSubmit}>
              <input
                type="text"
                name="name"
                placeholder="Full Name *"
                value={formData.name}
                onChange={handleChange}
              />
              <input
                type="email"
                name="email"
                placeholder="Email Address *"
                value={formData.email}
                onChange={handleChange}
              />
              <input
                type="tel"
                name="phone"
                placeholder="Phone Number"
                value={formData.phone}
                onChange={handleChange}
              />
              <input
                type="text"
                name="subject"
                placeholder="Subject *"
                value={formData.subject}
                onChange={handleChange}
              />
              <textarea
                name="message"
                rows="5"
                placeholder="Your Message *"
                value={formData.message}
                onChange={handleChange}
              ></textarea>
              <button type="submit">Send Message</button>
            </form>
          </div>
        </div> */}
      </section>

      {/* ================= MAP SECTION ================= */}
      <section className="map-section">
        <div className="map-container">
          <h2>Find us on Map</h2>
          <p>Government Women College, Satellite Town, Gujranwala</p>

          <div className="map-box">
            {/* <iframe
              title="Women College Gujranwala"
              src="https://www.google.com/maps?q=Government%20Women%20College%20Satellite%20Town%20Gujranwala&output=embed"
              loading="lazy"
            ></iframe> */}
            {/* <div className="map-box">
              <iframe
                src="https://www.google.com/maps/d/embed?mid=1UlmbI4wpGeVZSAIULHapsT0rEe2HTv0&ehbc=2E312F"
                width="100%"
                height="450"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                title="NextGen Campuses"
              ></iframe>
            </div> */}
            <iframe
              src="https://www.google.com/maps/d/embed?mid=1UlmbI4wpGeVZSAIULHapsT0rEe2HTv0&ehbc=2E312F"
              width="640"
              height="480"
            ></iframe>
          </div>
        </div>
      </section>
    </div>
  );
}
